import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { getAllProductsRelatedProducts, getRelatedProductsPaginated } from '../network/api/product.js';
import Card from '../Componants/Card.js';
import "../Componants/searchComponent/SearchProduct.css";

const RelatedProductsView = ({ update_p, personal }) => {
  const { categoryId, productId, page } = useParams();
  const [currentPage, setCurrentPage] = useState(parseInt(page, 10) || 1);
  const [totalPages, setTotalPages] = useState(1);
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await getAllProductsRelatedProducts({categoryId, productId, currentPage});
        setProducts(response.data.products);
        setTotalPages(response.data.totalPages);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    fetchProducts();
  }, [categoryId, productId, currentPage]);

  const handlePageClick = (newPage) => {
    setCurrentPage(newPage);
    navigate(`/relatedproducts/${categoryId}/${productId}/${newPage}`);
  };

  const renderPageLinks = () => {
    const links = [];
    for (let i = 1; i <= totalPages; i++) {
      links.push(
        <Link
          key={i}
          to={`/relatedproducts/${categoryId}/${productId}/${i}`}
          className={i === currentPage ? 'active' : ''}
          onClick={() => handlePageClick(i)}
        >
          {i}
        </Link>
      );
    }
    return links;
  };

  return (
    <div className='p-5'>
      <h1>Related Products</h1>
      <div className='cards'>
        <div className='row'>
          {products?.map((product, index) => (
            <div className="col-6 col-lg-3 mb-3" key={index}>
              <Card
                ImageCard={product.images[0]?.secure_url}
                update_p={update_p}
                personal={personal}
                brand={product.brand}
                name={product.name}
                price={product.price_after}
                id={product._id}
                rate={product.averageRating || 0}
                price_after={product.price_after}
                price_before={product.price_before}
                product={product}
              />
            </div>
          ))}
        </div>
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          {renderPageLinks()}
        </div>
      )}
    </div>
  );
};

export default RelatedProductsView;
